// extracted by mini-css-extract-plugin
export default {"Badges":"Badges_Badges__z3kAu","Title":"Badges_Title__FW3vE"};